import { filesQueryPollInterval } from '../../configs/poll-interval';
import {
  FileBrowserStorageObjectFragment,
  FileStatus,
} from '../../graphql/generated';
import { isFile } from '../../graphql/utils/utils';
import {
  PollConfigCondition,
  useDynamicPolling,
} from '../use-dynamic-polling/use-dynamic-polling';

type UseEnableDynamicFilesPolling = {
  startPolling: (interval: number) => void;
  stopPolling: () => void;
  data?: FileBrowserStorageObjectFragment[];
};

const isAwaitingUpload = (object: FileBrowserStorageObjectFragment) =>
  isFile(object) && object.status === FileStatus.AWAITING_UPLOAD;
const isProcessing = (object: FileBrowserStorageObjectFragment) =>
  isFile(object) && object.status === FileStatus.PROCESSING;

export const generateFilesPollingConditions = (
  data?: FileBrowserStorageObjectFragment[]
): PollConfigCondition[] => [
  {
    condition: !!data?.some(isAwaitingUpload),
    interval: filesQueryPollInterval.ONE_SECOND,
  },
  {
    condition: !!data?.some(isProcessing),
    interval: filesQueryPollInterval.FIVE_SECONDS,
  },
];

export const useEnableDynamicFilesPolling = ({
  stopPolling,
  startPolling,
  data,
}: UseEnableDynamicFilesPolling) => {
  const pollConfig = {
    defaultInterval: filesQueryPollInterval.DEFAULT,
    conditions: generateFilesPollingConditions(data),
  };

  const { pausePolling, resumePolling } = useDynamicPolling({ startPolling, stopPolling, pollConfig });

  return { pausePolling, resumePolling };
};
